import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import api from '@/utils/api';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('username', credentials.username);
      formData.append('password', credentials.password);

      // Cookie is set automatically by the backend (httpOnly)
      // CSRF token is also set by the backend
      await api.post(`${API_BASE}/admin/token`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Connexion réussie');
      navigate('/admin/leads');
    } catch (error) {
      console.error('Login error:', error);
      const detail = error.response?.data?.detail;
      if (detail && detail.includes('Default credentials')) {
        toast.error('Changement de mot de passe requis', {
          description: 'Veuillez changer le mot de passe par défaut.'
        });
      } else {
        toast.error('Identifiants incorrects', {
          description: 'Vérifiez votre nom d\'utilisateur et mot de passe.'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md" data-testid="login-card">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl" style={{ fontFamily: 'var(--font-heading)' }}>
            Admin Login
          </CardTitle>
          <CardDescription>Homely Solutions Dashboard</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="username">Nom d'utilisateur</Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="admin"
                required
                data-testid="input-username"
              />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="••••••••"
                required
                data-testid="input-password"
              />
            </div>
            <Button
              type="submit"
              className="w-full"
              style={{ backgroundColor: 'var(--cta-blue)' }}
              disabled={loading}
              data-testid="login-button"
            >
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
            <p className="text-xs text-muted-foreground text-center mt-4">
              Défaut: admin / admin123 (changement obligatoire)
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
